import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { after, before } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-mist px-5 py-16 md:py-24" aria-labelledby="before-after-title" data-id="element-106" data-mp="26lurs7sm6u9t">
      <div className="mx-auto max-w-6xl" data-id="element-107" data-mp="22l12pb3fr9fc">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm text-balance" data-id="element-108" data-mp="22m2czdcmnrw0">
          From memorizing ECG strips to understanding a structured process
        </p>
        <h2 id="before-after-title" className="mx-auto mt-3 max-w-4xl text-center font-display text-3xl font-black leading-tight text-navy-900 sm:text-5xl text-balance" data-id="element-109" data-mp="2u9ugz3aa2cma">
          You Don’t Need Another Collection of Random Rhythm Charts. You Need a Clearer Way to Study Them.
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-110" data-mp="19w3lzcevhkop">
          <div className="overflow-hidden rounded-3xl bg-white ring-1 ring-pulse/20" data-id="element-111" data-mp="19usi7clfgcxl">
            <div className="flex items-center gap-3 bg-pulse-100 px-6 py-5" data-id="element-112" data-mp="176no5xatjb7j">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-pulse text-white" data-id="element-113" data-mp="1c4paqs7gdsnr">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-114" data-mp="y3wcpxhy0ffw" />
              </span>
              <div data-id="element-115" data-mp="132g2ya3kkde2">
                <h3 className="font-display text-2xl font-black text-pulse-600" data-id="element-116" data-mp="135vh9apf5ief">BEFORE</h3>
                <p className="text-sm font-semibold text-pulse-600/80" data-id="element-117" data-mp="odjtq9ps0ubv">Without a structured ECG learning system</p>
              </div>
            </div>
            <ul className="divide-y divide-pulse/10 px-6" data-id="element-118" data-mp="feq0mtbnmm32">
              {before.map(item => <li key={item} className="flex items-start gap-3 py-4 text-[16px] leading-snug text-ink/80" data-id="element-119" data-mp="jf9zq2fsfzru">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-pulse" strokeWidth={3} aria-hidden="true" data-id="element-120" data-mp="5fqrl9mz8ofj" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl bg-white shadow-[0_24px_50px_-24px_rgba(15,157,107,0.55)] ring-2 ring-heal" data-id="element-121" data-mp="2c4j34igj3mst">
            <div className="flex items-center gap-3 bg-heal px-6 py-5 text-white" data-id="element-122" data-mp="27c9d72feymqj">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-heal" data-id="element-123" data-mp="23cqumdb2enqv">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-124" data-mp="1yepadp1wkidt" />
              </span>
              <div data-id="element-125" data-mp="2v10zjd6boave">
                <h3 className="font-display text-2xl font-black" data-id="element-126" data-mp="2r1jswgf5t7on">AFTER</h3>
                <p className="text-sm font-semibold text-white/90" data-id="element-127" data-mp="2r2bgb3ylrz3u">With ECG Interpretation Blueprint™</p>
              </div>
            </div>
            <ul className="divide-y divide-heal/10 px-6" data-id="element-128" data-mp="2h3vlor0da7pl">
              {after.map(item => <li key={item} className="flex items-start gap-3 py-4 text-[16px] font-medium leading-snug text-ink" data-id="element-129" data-mp="1antb66v4akwj">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-heal" strokeWidth={3} aria-hidden="true" data-id="element-130" data-mp="15n5m3qqg8e4y" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-extrabold leading-snug text-navy-900 sm:text-2xl text-balance" data-id="element-131" data-mp="10k4qin7bozih">
          The difference isn’t having more information. It’s having a clearer way to organize what you’re learning.
        </p>

        <SectionCTA label="Yes! I want a clearer approach to ECG interpretation" data-id="element-132" data-mp="1ebjbgzksjas6" />
      </div>
    </section>;
}